import {createFileRoute, Outlet, useLocation} from '@tanstack/react-router';

import PatientDetail from '@/practitioner/views/patient/PatientDetail';

function PatientsLayout() {
  const {pathname} = useLocation();
  const isRoot = /^\/u\/patients\/[a-z0-9-]{36}$/.test(pathname);
  return isRoot ? <PatientDetail /> : <Outlet />;
}

export const Route = createFileRoute('/(practitioner)/patients/$patientId')({
  component: PatientsLayout,
  loader: ({params}) => ({
    patientId: params.patientId
  })
});
